<template>
  <div class="banner-root mb-2 mb-md-4 position-relative rounded-bottom z-2">
    <div class="photocredit fs-7" v-if="!templateGroup">© Mareen Fischinger / Westend61</div>
    <slot name="media">
      <!-- банер із налаштувань порталу за наявності imgUrl, інакше локальний фолбек -->
      <template v-if="portalBanner && imgUrl">
        <b-img-lazy :src="imgUrl" class="object-fit-cover w-100" alt="Job" style="height: 30rem;" />
      </template>
      <template v-else-if="individual">
        <b-img-lazy :src="require(`@/assets/img/banner/${sid}/${imgName}.${imgExt}`)" class="object-fit-cover w-100" alt="Job" style="height: 30rem;" />
      </template>
      <template v-else>
        <b-img-lazy :src="require(`@/assets/img/banner/${imgName}.${imgExt}`)" class="object-fit-cover w-100" alt="Portal Job" style="height: 30rem;" />
      </template>
      <div class="banner-title position-absolute top-0 start-0 text-white display-1 pt-5 px-5 d-none d-md-flex">
        <span v-html="title"></span>
      </div>
    </slot>
    <div
      v-if="$slots.media"
      class="banner-content d-flex w-100 pt-3"
    >
      <slot></slot>
    </div>
    <div v-else class="banner-content position-absolute bottom-0 top-0 d-flex align-items-end p-3 p-md-5 w-100" :class="[{'mb-4 mb-sm-5': !isCurses}]">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { group, groupCurses, portalBannerGroup } from '@/config/configuration';

@Component
export default class BannerComponent extends Vue {
  @Prop(String) readonly imgName: string | undefined

  @Prop({ default: 'jpg' }) readonly imgExt!: string

  @Prop(String) readonly title: string | undefined

  @Prop(String) readonly imgUrl: string | undefined

  @Prop(String) readonly page: string | undefined

  @Prop({ default: false }) individual!: boolean;

  get sid() {
    return AppModule.sid;
  }

  get templateGroup() {
    return group(this.sid);
  }

  get portalBanner() {
    return portalBannerGroup(this.sid);
  }

  get isCurses() {
    return groupCurses(this.sid);
  }
}
</script>

<style lang="scss" scoped>
// Контент банера був абсолютним у фіксованих 30rem картинки: коли він вищий —
// вилазив угору поверх шапки, коли нижчий — зверху лишалася пуста дірка.
// Тепер картинка — тло, а контент іде в потоці, тож банер рівно по контенту.
.banner-root::v-deep > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
}

.banner-root::v-deep > .banner-content.position-absolute {
  position: relative !important;
  min-height: 16rem;
  margin-bottom: 0 !important;
}

// заголовок теж у потік, інакше на нижчому банері він наліз би на контент
.banner-root::v-deep > .banner-title.position-absolute {
  position: relative !important;
  padding-bottom: 0;
}
</style>
